'use client';

import type { ReactElement } from 'react';
import ChangeLocalization from './components/change-localization';
import dynamic from 'next/dynamic';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

const AuthButton = dynamic(() => import('./components/auth-button'), {
  loading: () => <LoadingSpinner />,
  ssr: false,
});

const ChangeTheme = dynamic(() => import('./components/change-theme'), {
  loading: () => <LoadingSpinner />,
  ssr: false,
});

export default function Actions(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-0.5 sm:gap-4">
      <div className="w-fit flex items-center justify-center gap-0.5 sm:gap-1">
        <ChangeLocalization />
        <ChangeTheme />
      </div>
      <AuthButton />
    </div>
  );
}
